export var ColorPresetName;
(function (ColorPresetName) {
    ColorPresetName["Forest"] = "Forest";
})(ColorPresetName || (ColorPresetName = {}));
export const COLOR_PRESETS = {
    [ColorPresetName.Forest]: {
        darker: '#232625',
        dark: '#35403A',
        mid: '#4C594F',
        light: '#A4A69C',
        lighter: '#BFBFB8',
    }
};
export function toCssColorString(color) {
    return '#' + toColorString(color);
}
export function toColorString(color) {
    return ('000000' + color.toString(16)).slice(-6);
}
//# sourceMappingURL=ColorPreset.js.map